export default __webpack_public_path__ + "static/ondre-sketch-1615f43c972b6851b84841485bffe7f0.png";